import useAddEstimateSection from '@/api/mutations/estimates/useAddEstimateSection';
import useRemoveEstimateLineItem from '@/api/mutations/estimates/useRemoveEstimateLineItem';
import useRemoveEstimateSection from '@/api/mutations/estimates/useRemoveEstimateSection';
import useReorderEstimateLineItems from '@/api/mutations/estimates/useReorderEstimateLineItems';
import useReorderEstimateSections from '@/api/mutations/estimates/useReorderEstimateSections';
import useUpdateEstimateLineItem from '@/api/mutations/estimates/useUpdateEstimateLineItem';
import useUpdateEstimateSection from '@/api/mutations/estimates/useUpdateEstimateSection';
import {
  ReorderEstimateLineItemsMutation,
  ReorderEstimateSectionsMutation,
} from '@/gql/graphql';
import { createOptimisticEstimateMutation } from './createOptimisticEstimateMutation';
import {
  applyOptimisticAddEstimateSection,
  applyOptimisticRemoveEstimateLineItem,
  applyOptimisticRemoveEstimateSection,
  applyOptimisticReorderEstimateLineItems,
  applyOptimisticReorderEstimateSections,
  applyOptimisticUpdateEstimateLineItem,
  applyOptimisticUpdateEstimateSection,
  ReorderEstimateLineItemsOptimisticVariables,
  ReorderEstimateSectionsOptimisticVariables,
} from './optimisticUpdates';

export const useOptimisticAddEstimateSection = createOptimisticEstimateMutation(
  {
    useBaseMutation: useAddEstimateSection,
    applyOptimisticUpdate: applyOptimisticAddEstimateSection,
  }
);

export const useOptimisticRemoveEstimateLineItem =
  createOptimisticEstimateMutation({
    useBaseMutation: useRemoveEstimateLineItem,
    applyOptimisticUpdate: applyOptimisticRemoveEstimateLineItem,
  });

export const useOptimisticRemoveEstimateSection =
  createOptimisticEstimateMutation({
    useBaseMutation: useRemoveEstimateSection,
    applyOptimisticUpdate: applyOptimisticRemoveEstimateSection,
  });

export const useOptimisticReorderEstimateLineItems =
  createOptimisticEstimateMutation<
    ReorderEstimateLineItemsMutation,
    ReorderEstimateLineItemsOptimisticVariables
  >({
    useBaseMutation: useReorderEstimateLineItems,
    applyOptimisticUpdate: applyOptimisticReorderEstimateLineItems,
  });

export const useOptimisticReorderEstimateSections =
  createOptimisticEstimateMutation<
    ReorderEstimateSectionsMutation,
    ReorderEstimateSectionsOptimisticVariables
  >({
    useBaseMutation: useReorderEstimateSections,
    applyOptimisticUpdate: applyOptimisticReorderEstimateSections,
  });

export const useOptimisticUpdateEstimateLineItem =
  createOptimisticEstimateMutation({
    useBaseMutation: useUpdateEstimateLineItem,
    applyOptimisticUpdate: applyOptimisticUpdateEstimateLineItem,
  });

export const useOptimisticUpdateEstimateSection =
  createOptimisticEstimateMutation({
    useBaseMutation: useUpdateEstimateSection,
    applyOptimisticUpdate: applyOptimisticUpdateEstimateSection,
  });
